<template>
        <v-content>
            <v-container fluid fill-height>
                <v-toolbar fixed color="cyan" dark class="epmc-head">
                    <v-toolbar-side-icon @click.stop="doSwitchDrawer"></v-toolbar-side-icon>
                    <v-toolbar-title>{{ this.$route.meta.title }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 class="change-pwd">
                        <v-form ref="ruleForm2" class="login-form">
                            <v-text-field :rules="rules2.checkPass" v-model="ruleForm2.checkPass"
                                          prepend-icon="lock" name="password" label="请输入新密码"
                                          type="password"></v-text-field>
                            <v-text-field :rules="rules2.checkPassAgain" v-model="ruleForm2.checkPassAgain"
                                          prepend-icon="lock" name="password" label="请再次输入密码"
                                          type="password"></v-text-field>
                        </v-form>
                        <v-btn color="cyan" @click="doChangePwd" class="white--text change-confirm">修改</v-btn>
                    </v-flex>

                    <v-snackbar auto-height
                                top
                                v-model="snackbarOption.show"
                                :color="snackbarOption.hintType"
                                :timeout="snackbarOption.timeout">
                        {{ snackbarOption.text }}
                        <v-btn dark
                               flat
                               @click="snackbarOption.show = false">
                            Close
                        </v-btn>
                    </v-snackbar>
                </v-layout>
            </v-container>
        </v-content>
</template>

<script>
    import NProgress from 'nprogress'
    import {mapMutations} from 'vuex'

    export default {
        name: "ChangePassword",
        data(){
            return {
                logining: false,
                ruleForm2: {
                    checkPass: '',
                    checkPassAgain: ''
                },
                rules2: {
                    checkPass: [
                        v => !!v || '请输入密码',
                        v => (v && v.length <= 20) || '登陆名不能超过20个字符'
                    ],
                    checkPassAgain: [
                        v => !!v || '请再次输入密码'
                    ]
                },
                checked: true,
                snackbarOption: { /*快速提示框*/
                    show: false,
                    hintType: '',
                    typeDict: ['success', 'info', 'error', 'cyan'],
                    text: ' Error ',
                    timeout: 4000,
                    typeEnum: {
                        success: '',
                        info: '',
                        error: '',
                        cyan: ''
                    },
                },
            }
        },
        computed:{
            drawer: {
                get() {
                    return this.$store.state.sysAdmin.drawer
                },
                set(value) {
                    this.SET_DRAWER(value)
                }
            },
        },
        methods:{
            ...mapMutations('sysAdmin', ['SET_DRAWER']),
            doSwitchDrawer() {
                this.drawer = true
            },
            /*调用snack组件*/
            callSnack(type, text, timeout) {            /*调用快速提示框*/
                this.snackbarOption.hintType = type
                this.snackbarOption.show = true
                this.snackbarOption.text = text
                if (!timeout) {
                    this.snackbarOption.timeout = 4000
                } else {
                    this.snackbarOption.timeout = timeout
                }
            },
            doChangePwd(){
                const pwdSame = this.ruleForm2.checkPass === this.ruleForm2.checkPassAgain
                if(!pwdSame) {
                    this.callSnack(this.snackbarOption.typeEnum.error, "两次输入的密码不一致")
                    return
                }
                if (this.$refs.ruleForm2.validate()) {
                    this.logining = true
                    NProgress.start()

                    this.$store.dispatch("employee/changePwd", this.ruleForm2.checkPass)
                        .then(response => {
                            this.logining = false
                            NProgress.done()
                            if (response.data.code !== 200) {
                                this.callSnack(this.snackbarOption.typeEnum.error, response.data.message)
                            } else {
                                this.callSnack(this.snackbarOption.typeEnum.success, response.data.message)
                            }
                        })
                }
            }
        },
        mounted() {
            this.snackbarOption.typeEnum = {
                success: this.snackbarOption.typeDict[0],
                info: this.snackbarOption.typeDict[1],
                error: this.snackbarOption.typeDict[2],
                cyan: this.snackbarOption.typeDict[3],
            }
        }
    }
</script>

<style scoped lang="scss">
.change-pwd{
    padding:0px 25px;
}
    .change-confirm{
        width: 150px;
        margin: 35px auto;
        display: block;
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// changePassword.vue?89f0752c